import proj1 from "./nutshell.jpg";
import proj2 from "./nutshell.jpg";
import proj3 from "./cover 2.jpg";
import proj4 from "./cover img.jpg";
import proj5 from "./nutshell.jpg";
import proj6 from "./nutshell.jpg";

const logotext = "Nithya Shri";
const meta = {
  title: "Nithya Shri",
  description:
    "I’m Nithya Shri data scientist _ Full stack devloper,currently working in Berlin",
};

const introdata = {
  title: "I’m Nithya Shri",
  animated: {
    first: "Web Developer",
    second: "Data Scientist",
    third: "Software Developer",
  },
  description:
    "As a highly motivated job seeker with a strong background in computer science and a passion for web development and data analysis, I am excited to showcase my skills and experience through my portfolio. With experience in a variety of programming languages and frameworks, as well as strong communication and collaboration skills, I am confident in my ability to excel as a web developer or data scientist. Thank you for considering me for the position. I look forward in discussing my qualifications further and how I can contribute to your team!",
  your_img_url: "https://images.unsplash.com/photo-1514790193030-c89d266d5a9d",
};

const dataabout = {
  title: "A bit about my self",
  aboutme:
    "Hello! My name is Nithya Shri and I am a recent graduate with a degree in B.Tech IT. I am excited to start my career as a web developer and data scientist, and I am eager to apply my skills and knowledge to real-world projects. In my studies, I have gained experience in a variety of programming languages and frameworks, including HTML, CSS, JavaScript, Python, and SQL. I am also passionate about data analysis and visualization, and have had the opportunity to work on projects using tools such as Pandas, NumPy, and Matplotlib. In addition to my technical skills, I am a strong team player with excellent communication and collaboration abilities. I am confident in my ability to make a positive contribution as a web developer or data scientist, and I am excited to continue learning and growing in my career. Thank you for considering me for the position.",
};
const worktimeline = [
  {
    jobtitle: "B.Tech Information Technology",
    where: "Prathyusha Engineering College",
    date: "2024",
  },
  {
    jobtitle: "HSLC",
    where: "Sethu Bhaskara Matric Higher Secondary School",
    date: "2020",
  },
  {
    jobtitle: "SSLC",
    where: "Sethu Bhaskara Matric Higher Secondary School",
    date: "2018",
  },
];

const skills = [
  {
    name: "Python",
    value: 90,
  },
  {
    name: "HTML, CSS & Javascript",
    value: 95,
  },
  {
    name: "Flask",
    value: 80,
  },
  {
    name: "React",
    value: 60,
  },
  {
    name: "Streamlit",
    value: 85,
  },
  {
    name: "Java",
    value: 70,
  },
];

const services = [
  {
    title: "Essay Writting Competition",
    description:
      'Won 1st Prize in Essay Writting Competition Conducted by "THE HINDU"',
    //   "I am proud to announce that I have won the first prize in the Essay Writing Competition conducted by "The Hindu". This achievement is a reflection of my dedication to writing and my commitment to improving my skills. I am grateful for the opportunity to participate in this competition and am thrilled to have come out on top. This award is a valuable addition to my personal portfolio and will help me stand out as I pursue further education or job opportunities. I am excited to continue honing my writing abilities and am looking forward to what the future holds."
  },
  {
    title: "Paper Presentation Competition",
    description:
      "1st Prize in Paper Presentation Competition Conducted by Jeppiar Engineering College-Chennai",
    //   'I am pleased to announce that I have won the first prize in the Paper Presentation Competition conducted by Jeppiar Engineering College in Chennai. This competition was a great opportunity for me to showcase my research and presentation skills, and I am honored to have been recognized for my efforts. This achievement is a valuable addition to my portfolio and demonstrates my ability to effectively communicate complex ideas to a wider audience. I am grateful for the opportunity to participate in this competition and am excited to continue building my skills in the field.',
  },
  {
    title: "Write up Competition",
    description:
      "1st Prize in Write up Competition Conducted by Prathyusha Engineering College- Thiruvallur",
  },
  {
    title: "Co-Author",
    description:
      "I am proud to be a co-author of three books that have been published on Amazon. This experience has allowed me to contribute my knowledge and expertise to a wider audience and has helped me develop my writing and collaboration skills. Being a co-author of these books is a significant achievement that I am proud to include in my portfolio. I am grateful for the opportunity to work with talented authors and am excited to continue contributing to the literary community.",
  },
];

const dataportfolio = [
  {
    img: proj2,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: proj3,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: proj4,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: proj1,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: proj5,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: proj6,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },

  {
    img: proj2,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: proj3,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: proj2,
    desctiption:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  // {
  //   img: proj,
  //   desctiption:
  //     "The wisdom of life consists in the elimination of non-essentials.",
  //   link: "#",
  // },
  // {
  //   img: proj,
  //   desctiption:
  //     "The wisdom of life consists in the elimination of non-essentials.",
  //   link: "#",
  // },
];

const contactConfig = {
  YOUR_EMAIL: "nithyashrirr@gmail.com",
  YOUR_FONE: "+91-7305225217",
  description:
    "Thank you for visiting my portfolio! If you have any questions or would like to get in touch, please don't hesitate to contact me. I am always open to hearing from fellow professionals, potential collaborators, and anyone who is interested in my work. To get in touch, you can fill out the form on this page or reach out to me directly at email address or phone number. I will do my best to respond to your message as soon as possible. I am available for freelance work, consulting, and full-time opportunities. Whether you are looking for a web developer, data scientist, or someone with a particular skill set, I am always open to exploring new opportunities!",
  // creat an emailjs.com account
  // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
  YOUR_SERVICE_ID: "service_xtktvxl",
  YOUR_TEMPLATE_ID: "template_gnhu8ft",
  YOUR_USER_ID: "CwiZugEQuVaK3lznu",
};

const socialprofils = {
  github: "https://github.com/Nithyashriramkumar",
  instagram: "https://www.instagram.com/nithyashriramkumar/",
  linkedin: "https://www.linkedin.com/in/nithya-shri-rr",
  //   twitter: "https://twitter.com",
};
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
};
